// theirs
import React from 'react'
import styled from 'styled-components'
import classNames from 'classnames'
// ours
import Frame from '../Frame'
import { getContent } from '../../content'
import { breakpoints } from '../../styles'

interface LandscapeProps {
    className?: string
    testId?: string
}

const baseClass = 'landscape'

const StyledLandscape = styled.div`
    &.${baseClass} {
        background-color: transparent;
        padding: 0;
        margin: 0;

        @media (min-width: ${breakpoints.lg}) {
            padding-bottom: 0;
        }

        .${baseClass}__frame {
            background: transparent;
            display: grid;
            z-index: 2;

            .${baseClass}__inner {
                display: table-cell;
                vertical-align: middle;
                text-align: center;
            }
        }
    }
`

const Landscape = ({ className, testId }: LandscapeProps) => {
    const contentCollection = getContent()
    return (
        <StyledLandscape
            className={classNames(baseClass, className)}
            data-testid={testId}
        >
            {contentCollection &&
                contentCollection.map((content, index) => (
                    <Frame
                        key={index}
                        className={`${baseClass}__frame`}
                        content={content}
                    />
                ))}
        </StyledLandscape>
    )
}
export default Landscape
